<div class="container-fluid">
    <h3><b>Access Denied!</b></h3>
    <div class="alert alert-danger" role="alert">
        You do not have the necessary permissions to perform this action. Please contact your system administrator for assistance
    </div>
</div>
